import React from "react";
import Typography from "@mui/material/Typography";

import { SectionPageTitleProps } from "src/library/types/types";

export default function SectionTitle(props: SectionPageTitleProps) {
  const { title, color } = props;

  return (
    <Typography
      component="h2"
      variant="h3"
      align="center"
      color={color}
      gutterBottom
      fontWeight="fontWeightExtraBold"
      sx={{ pt: 2, pb: 1 }}
    >
      {title}
    </Typography>
  );
}
